import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { VALIDATION_PATTERNS } from '../validators/validator-patterns.enum';

@Component({
  selector: 'partnerhub-error-validation',
  templateUrl: './error-validation.component.html',
  styleUrls: ['./error-validation.component.scss'],
  animations: [
    trigger('errorState', [
      transition(':enter', [style({ opacity: 0 }), animate('400ms', style({ opacity: 1 }))]),
      transition(':leave', [animate('200ms', style({ opacity: 0 }))]),
    ]),
  ],
})
export class ErrorValidationComponent implements OnInit {
  @Input() public errors: ValidationErrors = null;

  /**
   * Additional condition to show the error message
   * ex: Touched, Dirty or any other condition
   */
  @Input() public invalid = false;

  @Input() public invalidByBackend: {
    isInvalid: boolean,
    message: string,
  } = { isInvalid: false, message: '' };

  public validationPatterns = VALIDATION_PATTERNS;

  constructor() {}

  public ngOnInit() {}
}
